<template>
    <div
        class="flex flex-row"
        :class="{ [value.state]: true, 'gap-1': withStateIcon }"
    >
        <CheckStateResultIcon
            v-if="withStateIcon"
            class="inline"
            :value="value"
        />

        {{ value.stateText }}
    </div>
</template>

<script lang="ts" setup>
import type { CheckResult } from '@/api/interfaces/identity-verification-report.api';
import CheckStateResultIcon from './CheckStateResultIcon.vue';

withDefaults(defineProps<{ value: CheckResult; withStateIcon?: boolean }>(), {
    withStateIcon: false,
});
</script>

<style scoped>
.failed,
.unverified {
    @apply text-semantic-destructive-primary-default;
}

.passed {
    @apply text-ds-green-500;
}
.needs_review {
    @apply text-content-primary;
}

.cautious_failed {
    @apply text-ds-yellow-500;
}
</style>
